export type EnabledCookieGroups = {
  initial: boolean;
  targeting: boolean;
  performance: boolean;
  functional: boolean;
};

export enum CookiesActions {
  SetEnabledCookieGroups = 'ENABLED_COOKIE_GROUPS/SET',
}

export interface CookiesStore {
  enabledCookieGroups: EnabledCookieGroups;
}
